module.exports = __webpack_public_path__ + "static/media/sherpa.cf5ff15e.gif";